import { PlpSearchResponse } from "@swo/storefront";

export function query(
  data: {
    localeCode: string;
    categoryKey: string;
    segmentKey: string;
  },
  facetsQuery: { [key: string]: string },
): Promise<PlpSearchResponse> {
  const search = new URLSearchParams({
    localeCode: data.localeCode,
    segmentKey: data.segmentKey,
    ...facetsQuery,
  });

  return fetch(`/storefront/search/product-listing/categories/${data.categoryKey}?${search.toString()}`)
    .then(res => {
      if (!res.ok) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw res;
      }
      return res;
    })
    .then(res => res.json())
    .then(json => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return json;
    })
    .catch(e => {
      console.log(e);
      return Promise.reject(new Error("invalid-query"));
    });
}
